<!DOCTYPE html>
<div class="modal-wrapper">
  <img class="imgs" [src]="image" alt="own images" />
  @if (bottomBarToggle) {
    <div class="bottom-bar">
      <div class="toggle-warpper">
        <input
          id="toggle-heart"
          [checked]="likedImg"
          type="checkbox"
          (change)="isChangeLimitAccessToggle($event.target.checked,selectedImageData)"
          />
          @if (showAnimation) {
            <ng-lottie
              class="fav-animation"
              [options]="reaction_options"
            ></ng-lottie>
          }
          <label for="toggle-heart" class="heart-css"
            ><ion-icon name="heart" class="heart-icon"></ion-icon
          ></label>
        </div>
        @if (addBtnHide) {
          <div class="toggle-warpper">
            @if (showaddAnimation) {
              <ng-lottie
                class="fav-animation coin-animation"
                [options]="options"
              ></ng-lottie>
            }
            <input id="toggle-add" type="checkbox" />
            <label
              for="toggle-add"
              class="heart-css"
              (click)="addAlbumImage(selectedImageData)"
              ><ion-icon class="add-icon" name="add-circle"></ion-icon
            ></label>
          </div>
        }
      </div>
    }
    @if (confirmRemoveImg) {
      <div
        class="conformationPopup"
        [ngStyle]="{'width.px': getWidth()}"
        [ngClass]="removePopup ? 'android-popup' : 'ios-popup' "
        >
        <div class="top-wrapper">
          <div class="text">
            <span>{{ "Lifestyle.points" | translate }}</span>
          </div>
          <div class="addImage">
            <button (click)="addAlbumImage(selectedImageData)">
              {{ "Lifestyle.add_image" | translate }}
            </button>
          </div>
        </div>
        <div class="cancle">
          <button (click)="close()">{{ "Lifestyle.cancel" | translate }}</button>
        </div>
      </div>
    }
  </div>
